import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrash, faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

const Crop = () => {
    const [value, setvalue] = useState("");
    const [cropData, setCropData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [deleteCode, setDeleteCode] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
     
        fetchData();
    }, []);

    const fetchData = async () => {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/crop`);
        setCropData(result.data.dataContent);
        setIsFetching(false);
    };

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'cropName',
                header: 'Crop Name',
            },
            {
                accessorKey: 'commonName',
                header: 'Common Name',
            },
            {
                accessorKey: 'cropCategoryName',
                header: 'Crop Category',
            },
            {
                accessor: '',
                header: 'Actions',
                Cell: cell => <>
                    <i className="btn text-primary" type="button" data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => navigate("/master/AddNewCrop", { state: { cropsDataCode: cell.row.original } })}><FontAwesomeIcon icon={faPencil} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#myDelete" onClick={() => setDeleteCode({ "cropcode": cell.row.original.cropCode })} > <FontAwesomeIcon icon={faTrashAlt} /></i></>

            },
            
        ],
        [],
    );

    // if (isFetching) {
    //     return (
    //         <>
    //          <AdminHeader />
    //         <AdminSideBar />
    //      <Box sx={{ display: "flex", justifyContent: "center" }}>
    //         <CircularProgress />
    //       </Box>
    //       </>
    //     );
    //   }

    function deleteData(value) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(deleteCode);

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/crop`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success == true) {
                    fetchData()
                }
            })
            .catch(error => console.log('error', error));
    }



    return (
        <>
            
            <main id="main" className="main">
            <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                   
                    <nav>
                    <h1> Crops</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Master</li>
                            <li className="breadcrumb-item active">Crops</li>
                        </ol>
                    </nav>
                    <button type="button" className="btn btn-success" onClick={() => navigate("/master/AddNewCrop")}>Add New</button>
                
                </div>
                <section className="section">
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">

                            <div className="card">

                                    <MaterialReactTable
                                    columns={columns}
                                    data={cropData } 
                                    enableColumnOrdering 
                                    enablePagination={true} 
                                    state={{ isLoading: isFetching ? true : false }}
                                   /> 
                            </div>

                        </div>

                        <div className="col-lg-6">

                        </div>
                    </div>
                    <div className="modal fade" id="myDelete" data-bs-backdrop="myDelete" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="deleteLabel"></h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                            </div>
                            <div className="modal-body">
                                <h6 id="deleteHeading">Are you sure you want to delete this item?</h6>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                                <button type="button" className="btn border" data-bs-dismiss="modal">No</button>

                            </div>

                        </div>
                    </div>
                </div>
                </section>

            </main>
           
        </>
    )
}

export default Crop;

